export default "/profile/images/Keruj.svg?0bc5b953471f95f162a1526a091c0eb8";